import store from "@/store";
import { markRaw } from "vue";

export const initModal = (app) => {
  app.config.globalProperties.$modal = {
    show: (modalComponent, props, params) => {
      const modalComp = typeof modalComponent === "string" ? modalComponent : markRaw(modalComponent);
      store.dispatch("modals/showModal", { modalComp, props, params }, { root: true });
    },
    hide: (modalComp) => {
      store.dispatch("modals/hideModal", modalComp, { root: true });
    }
  };
};
